module.exports = __webpack_public_path__ + "img/szhx_titIcon6.1a329620.png";